import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { Programs } from './pages/Programs';
import { ProgramDetail } from './pages/ProgramDetail';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { HowItWorks } from './pages/HowItWorks';
import { Labs } from './pages/Labs';
import { Pricing } from './pages/Pricing';
import { About } from './pages/About';
import { GetStarted } from './pages/GetStarted';
import { BrandProvider } from './contexts/BrandContext';
interface AppProps {
  /** Which client brand the template renders. Adding a brand is a theme entry, not a fork. */
  brand?: 'republic' | 'verdant';
}
export function App({
  brand = 'verdant'
}: AppProps) {
  return <BrandProvider brandId={brand} data-id="element-0" data-mp="23w4ek0vqj40u">
      <BrowserRouter data-id="element-1" data-mp="23v2sl1d6kx4c">
        <ScrollToTop data-id="element-2" data-mp="23ti5fwt74ggi" />
        <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-3" data-mp="3ikh829m9asyz">
          <Header data-id="element-4" data-mp="3ii4ro0w5cqo1" />
          <Routes data-id="element-5" data-mp="3mlayb9n68jv1">
            <Route path="/" element={<Home data-id="element-7" data-mp="3mjzsl4a6121a" />} data-id="element-6" data-mp="3mkrchhuehbbq" />
            <Route path="/programs" element={<Programs data-id="element-9" data-mp="3rcj2nr9n9f1c" />} data-id="element-8" data-mp="3mjg93j4va5l5" />
            <Route path="/programs/:slug" element={<ProgramDetail data-id="element-11" data-mp="3recctgjguhe3" />} data-id="element-10" data-mp="3rdatkosaqola" />
            <Route path="/shop" element={<Shop data-id="element-13" data-mp="4n4bxqxqh8g" />} data-id="element-12" data-mp="6hqffdy0fe4" />
            <Route path="/shop/:slug" element={<ProductDetail data-id="element-15" data-mp="2zld1d7i6tbah" />} data-id="element-14" data-mp="56m9egl55mh" />
            <Route path="/how-it-works" element={<HowItWorks data-id="element-17" data-mp="2zn6actg9w7ln" />} data-id="element-16" data-mp="2zm4wkh7vh708" />
            <Route path="/labs" element={<Labs data-id="element-19" data-mp="33nq5xsl7735o" />} data-id="element-18" data-mp="33mf25srr5vek" />
            <Route path="/pricing" element={<Pricing data-id="element-21" data-mp="33ohzyyz5cstu" />} data-id="element-20" data-mp="33n6xd2hftr4b" />
            <Route path="/about" element={<About data-id="element-23" data-mp="38l06o4e1f18t" />} data-id="element-22" data-mp="38l8h7pmotugu" />
            <Route path="/get-started" element={<GetStarted data-id="element-25" data-mp="3dkl0k0ecojeo" />} data-id="element-24" data-mp="38nunzn1r85y0" />
            <Route path="*" element={<Home data-id="element-27" data-mp="3dm6064fiusje" />} data-id="element-26" data-mp="3dlw9sfqkejd6" />
          </Routes>
          <Footer data-id="element-28" data-mp="nvst52eusjuw" />
        </div>
      </BrowserRouter>
    </BrandProvider>;
}
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [pathname]);
  return null;
}